import { createContext } from 'react';

import { SelectedOrganizationContextProps } from './SelectedOrganizationContext.types';

export const SelectedOrganizationContext = createContext<SelectedOrganizationContextProps | undefined>(undefined);
